export default {
  PUSH_TP: 'PUSH_TP',
  PUSH_TPS: 'PUSH_TPS',
  RESET_TPS_STATE: 'RESET_TPS_STATE',
  REPLACE_TP: 'REPLACE_TP',
  REPLACE_TPS: 'REPLACE_TPS',
  SET_TP_IS_LOADING: 'SET_TP_IS_LOADING',
  SET_IS_EDITING_TP: 'SET_IS_EDITING_TP',
  SET_SELECTED_TP_GUID: 'SET_SELECTED_TP_GUID',
  SET_IS_ADDING_NEW_PHASE: 'SET_IS_ADDING_NEW_PHASE'
};
